import React from 'react';

export default ({title, subtitle}) =>
  <div className="container">
    <h2 className="section-title pt-40 mb-0 text-center">{title}</h2>
    {subtitle && <p className="section-paragraph mt-10 mb-20 text-center">{subtitle}</p>}
  </div>
